module.exports = __webpack_public_path__ + "img/C-one1.2bd0eae1.png";